import { ShoppingCart } from './shopping-cart';

export class Order { 
  datePlaced: number; 
  items: any[];

  constructor(public userId: string, public shipping: any, shoppingCart: ShoppingCart) {
    this.datePlaced = new Date().getTime();

    this.items = shoppingCart.items.map(i => {
      return {
        product: {
          title: i.title,
          imageUrl: i.imageUrl,
          price: i.price
        },
        quantity: i.quantity,
        totalPrice: i.totalPrice
      }
    })    
  }
}


// WEBPACK FOOTER //
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/shared/models/order.ts